import Multiple from './Multiple'
import { routeData } from "../data";
import AnnotationSync from './AnnotationSync';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { isMobile, isTablet } from 'react-device-detect';
const SketchfabConfigurator = () => {

    return (
        <>
            <Row className=' d-flex flex-column justify-content-center align-items-center '>
                <Row className='max-width-set player-height-constant py-2 my-2 py-md-3 my-md-3'>
                    <Col sm={12} lg={9} className=''>
                    <Multiple currentData={routeData[0].electrofusionOptimized}/>
                    </Col>
                    <Col sm={12} lg={3} className='sideview-text-container'>
                        <b className='  '>Inspection-Sync Player</b>
                        <p className=' white-space-remove '>
                        Ideal for both meticulous inspections and comprehensive training. Effortlessly compare and inspect two models with side by side, synchronized for a detailed and insightful analysis.
                        </p>
                    </Col>
                </Row>
                <Row className='max-width-set player-height-constant py-2 my-2 py-md-3 my-md-3'>
                    <Col sm={12} lg={9} className='annotation-sync-container'>
                        <AnnotationSync/>
                    </Col>
                    <Col sm={12} lg={3} className='sideview-text-container'>
                        <b>Annotation Sync Player</b>
                        <p className=''>
                        Our Annotation Sync Player excels in visualizing intricate information, making it ideal for products with numerous subcomponents. This tool seamlessly guides you through detailed explanations, ensuring a front-row view and a comprehensive understanding at every step.
                        </p>
                    </Col>
                </Row>
                <Row className='max-width-set player-height-constant py-2 my-2 py-md-3 my-md-3'>
                        <Col sm={12} lg={9} className='annotation-sync-container'>
                            <Row className='maintopARcontainer'>
                                <Col sm={12} md={9} className='px-0'>
                                    <div className="maintopARcontainer- row py-2 mx-1">
                                        <img className='mainImage-AR' src="Image\AR-truck-inspection.png" alt="image"/>
                                    </div>
                                    {/* <img src="Image\box-shadow.png" alt="qr-code" className='row px-0 mx-0 shadow-img'/> */}
                                </Col>
                                <Col sm={12} md={3} className='py-1 py-md-2 px-1 side-div-arplayer'>
                                    <Row className="bg-white rounded-5 py-3 px-1 mx-2 text-box-arplayer">
                                        <Col xs={12} className='text-start ar-player-info-text'>
                                            <span style={{fontSize: '13px', fontWeight: 'bold'}}>Scan this code to open the model on your device, then, tap on the AR icon :</span>
                                        </Col>
                                        {(isMobile || isTablet ) ? 
                                            <Col xs={12} className='my-1 my-lg-2 d-md-block d-lg-none px-0'>
                                                <a href="https://testing.paracosma.com/ar-object-viewer/312bde93789d482a9eae61826a1610ea" target='_blank' className='blue-btn py-2 ar-text-button'> <img src="Image\ar-icon.svg" height="22px" className=' text-white' /> Open AR View ! </a>
                                            </Col>
                                        :
                                            <Col xs={12} >
                                                <img src="Image\truck-inspection-qrcode.png" alt="" className='p-2 qr-code-truck' />
                                            </Col>
                                        }

                                        <Col xs={12} className='text-start ar-player-info-text'>
                                            <span className="bot-into-ar" style={{fontSize: '12px'}}>
                                                Augmented Reality is only available on mobile or tablet device
                                                <br />
                                                <span>Supported devices : iPhone 6s+ & iPad5+ on iOS 12+ and Android 8.0+ with ARCore 1.9 support</span>
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={12} lg={3}>
                        <div className="sideview-text-container">
                            <b>AR Player</b>
                            <p className=''>
                            Step into a new dimension of interactive experiences with our Augmented Reality (AR) Player. Seamlessly merging the digital and physical worlds, this player transforms your surroundings by overlaying rich, dynamic content. Elevate your reality and explore endless possibilities with our immersive AR Player.
                            </p>
                        </div>
                        </Col>
                </Row>
            </Row>
        </>
    )
}

export default SketchfabConfigurator